import { Avatar, Grid, Stack } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { useFormContext, useWatch } from "react-hook-form";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { deepOrange, deepPurple, blue, green, pink, amber } from "@mui/material/colors";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { useParams } from "react-router-dom";

type TContactInfo = {
  readonly?: boolean;
};
const colors = [deepOrange[500], deepPurple[500], blue[500], green[500], pink[500], amber[500]];
const getRandomColor = () => {
  const index = Math.floor(Math.random() * colors.length);
  return colors[index];
};
export const ContactInfo: FC<TContactInfo> = ({ readonly }) => {
  const { control } = useFormContext<TCompanyForm>();
  const { companyId } = useParams();

  const [bgColor] = useState<string>(() => {
    if (!companyId) {
      return getRandomColor();
    }
    const savedColor = localStorage.getItem(`companyBgColor_${companyId}`);
    if (savedColor) return savedColor;
    const newColor = getRandomColor();
    localStorage.setItem(`companyBgColor_${companyId}`, newColor);
    return newColor;
  });

  const contactPersonName = useWatch({ control, name: "contactPersonName" });
  const [firstChar, setFirstChar] = useState<string>();

  useEffect(() => {
    if (contactPersonName) {
      const char = contactPersonName.charAt(0).toUpperCase();
      setFirstChar(char);
    }
  }, [contactPersonName]);

  return (
    <Stack>
      <InnerBox title={<CompanyFormTitle text="担当者情報" />}>
        <Grid
          container
          spacing={1}
          sx={{
            marginBottom: "16px",
          }}
        >
          <Grid item xs={6}>
            <FormField
              control={control}
              name="contactPersonName"
              sx={{
                label: { marginLeft: "50px" },
                "p.Mui-error": { marginLeft: "50px" },
              }}
            >
              <Stack direction="row" alignItems="center" gap={2}>
                <Avatar sx={{ width: 32, height: 32, bgcolor: bgColor }}>{firstChar}</Avatar>
                <Input readonly={readonly} sx={{ width: "100%" }} />
              </Stack>
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="contactPersonJobTitle">
              <Input readonly={readonly} />
            </FormField>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <FormField control={control} name="contactPersonPhone">
              <Input fullWidth readonly={readonly} />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="contactPersonEmail">
              <Input fullWidth readonly={readonly} />
            </FormField>
          </Grid>
        </Grid>
      </InnerBox>
    </Stack>
  );
};
